var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-md-8 col-lg-9"
  }, [_c('h5', {
    staticClass: "mb-2 mb-md-1"
  }, [_vm._v(" " + _vm._s(_vm.domainIndicator.Name) + " "), _c('i', {
    staticClass: "fas fa-info-circle text-muted",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": _vm.domainIndicator.Description,
      "original-title": _vm.domainIndicator.Description
    }
  })]), _c('p', {
    staticClass: "text-muted m-0"
  }, [_vm._v(_vm._s(_vm.domainIndicator.Question))])]), _c('div', {
    staticClass: "col-md-4 col-lg-3 mt-4 mt-md-0"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [!_vm.fact.IndicatorPointsEarned || _vm.fact.IneligibilityReasonId ? _c('div', {
    staticClass: "pertentage-bar",
    staticStyle: {
      "opacity": "0.45"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "progress mt-1"
  }, [_c('div', {
    ref: "bar",
    staticClass: "progress-bar bg-dark",
    staticStyle: {
      "width": "0%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "0",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])]) : _vm._e(), _vm.fact.IndicatorPointsEarned && !_vm.fact.IneligibilityReasonId ? _c('PercentageBar', {
    attrs: {
      "value": _vm.percentage,
      "label": "State"
    }
  }) : _vm._e()], 1)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex overflow-hidden"
  }, [_c('div', {
    staticClass: "font-weight-bold flex-fill text-truncate"
  }, [_vm._v("State")]), _c('i', {
    staticClass: "text-muted"
  }, [_vm._v("N/A")])]);
}];
export { render, staticRenderFns };